module.exports = __webpack_public_path__ + "img/cesar-acuna.c73da74f.png";